import { useCallback, useEffect, useReducer } from 'react'
import { throwUnsupportedValue } from 'src/utils'
import { ADD_TOAST_EVENT } from './constants'
import type { ToastPayload } from './types'

export function useToasts() {
  const [data, dispatch] = useReducer(reducer, [])

  const removeToast = useCallback((id: string) => {
    dispatch({ type: 'REMOVE', payload: { id } })
  }, [])

  useEffect(() => {
    function addToast(e: CustomEvent<ToastPayload>) {
      dispatch({ type: 'ADD', payload: e.detail })
    }

    window.addEventListener(ADD_TOAST_EVENT, addToast as EventListener)
    return () => {
      window.removeEventListener(ADD_TOAST_EVENT, addToast as EventListener)
    }
  }, [])

  return [data, removeToast] as const
}

function reducer(
  state: ToastPayload[],
  action:
    | { type: 'ADD'; payload: ToastPayload }
    | { type: 'REMOVE'; payload: { id: string } },
) {
  const { type, payload } = action

  switch (type) {
    case 'ADD':
      if (state.some((item) => item.id === payload.id)) {
        return state.map((item) => (item.id === payload.id ? payload : item))
      }
      return [...state, payload]
    case 'REMOVE':
      return state.filter((item) => item.id !== payload.id)
    default:
      throwUnsupportedValue(type)
  }
}
